export default __webpack_public_path__ + "static/media/lgbt.dbea5ec0.svg";